export default __webpack_public_path__ + "static/media/concentric.75fbfb54.png";